import { observer } from 'mobx-react-lite';
import { useContent, useUi } from '@/stores/RootStore';
import { useReveal } from '@/hooks/useReveal';
import Button from '@/components/ui/Button';
import SectionHeader from '@/components/ui/SectionHeader';
import s from './Services.module.scss';

// 고객 지원 — 목업 실측(2026-07-31, 사용자 제공 이미지 대조):
//   좌: 제목("고객 지원") + 항목 리스트(제목 18/300, 부제 14/500 회색, 항목 구분선; 활성=시안 제목+시안 밑줄)
//   가운데: 세로 구분선(패널 border-left)
//   우: 활성 항목 상세 — 시안 라벨(이름) + 제목(이름 32/400) + 설명 + 시안 버튼. ★이미지 없음★
//   활성 상태 MobX(UiStore.activeService). 좌 리스트 hover/클릭 → 우 패널 교체.
//   변경 금지 트리거: 우 패널에 이미지 넣지 말 것(목업엔 없음). 활성 항목 밑줄은 시안.
const Services = observer(() => {
  const { services } = useContent();
  const ui = useUi();
  const ref = useReveal<HTMLDivElement>();
  const active = services.items[ui.activeService] ?? services.items[0];

  return (
    <section className={s.section}>
      <div className={s.inner}>
        <div className={s.layout} ref={ref}>
          {/* 좌: 제목 + 항목 리스트 */}
          <div className={s.left}>
            <SectionHeader title={services.sectionTitle} />
            <ul className={s.list}>
              {services.items.map((it, i) => (
                <li key={it.id}>
                  <button
                    type="button"
                    className={`${s.item} ${i === ui.activeService ? s.on : ''}`}
                    onClick={() => ui.setActiveService(i)}
                  >
                    <span className={s.itemTitle}>{it.label}</span>
                    <span className={s.itemSub}>{it.sub}</span>
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* 우: 활성 항목 상세(이미지 없음) — 세로 구분선은 .panel border-left */}
          <div className={s.panel} key={active.id}>
            <span className={s.label}>{active.label}</span>
            <h3 className={s.panelTitle}>{active.label}</h3>
            <p className={s.desc}>{active.desc}</p>
            <Button variant="pill" href="#" onClick={(e) => e.preventDefault()}>{active.cta}</Button>
          </div>
        </div>
      </div>
    </section>
  );
});

export default Services;
